export class DownloadAutomatico {

    // Gera o hyperlink automaticamente para download de arquivos em navegadores que não sejam IE e Edge
    public static RealizarDownload(data: any, nomeArquivo: string) : void {

        // Cria a url de representação do objeto 
        let url = window.URL.createObjectURL(data);
    
        // Cria o hyperlink em html
        let hyperlink = document.createElement('a');

        // Acressenta o hyperlink ao corpo
        document.body.appendChild(hyperlink);

        // Define o hyperlink como não visível
        hyperlink.setAttribute('style', 'display: none');

        // Associa a url da representação do objeto para ser utilizado como link
        hyperlink.href = url;

        // Associa o nome do arquivo ao hyperlink
        hyperlink.download = nomeArquivo;

        // Força o clique para a realização do download automatizado
        hyperlink.click();

        // Libera a url de representação do objeto pois a mesma não será mais usada
        window.URL.revokeObjectURL(url);

        // Remove o hyperlink
        hyperlink.remove(); 
    }

    // Converte o arquivo em Base64 para um array buffer para que possa ser transformado em blob
    // Conteúdo deve ser enviado sem o prefixo, por exemplo: data:application/pdf;base64
    public static ConverterBase64ParaArrayBuffer(data: string) {

        // atob: Irá realizar o decode da string que foi codificada via base64 em uma nova string
        // nessa nova string cada caractere representa um byte de uma informação binária
        const characteres = atob(data);

        // Cria um array contendo os códigos char para cada caractere
        const byteNumbers = new Array(characteres.length);

        for (let i = 0; i < characteres.length; i++) {
          byteNumbers[i] = characteres.charCodeAt(i);
        }

        return new Uint8Array(byteNumbers);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/arquivo/download-automatico.ts